
import type { PropOptions } from 'vue';
import Vue from 'vue';
import MultiselectForm from '~/components/common/MultiselectForm/MultiselectForm.vue';
import type { IProductType } from '~/types/community';
import type { CreateProductResponse } from '~/types/api';

interface IComponentData {
  productTypes: Array<IProductType>;
}

export default Vue.extend({
  name: 'WarRoomEditProfileFormProductTypes',
  components: {
    MultiselectForm,
  },
  props: {
    autoAttachProduct: {
      type: Boolean,
      default: true,
    } as PropOptions<boolean>,
  },
  data(): IComponentData {
    return {
      productTypes: [],
    };
  },
  async mounted() {
    const { product_types: productTypes } = await this.$api.$get('/api/product_types.json', {
      params: {
        custom: false,
      },
    });
    this.productTypes = productTypes;
  },
  methods: {
    async createProductType(name: string): Promise<IProductType | void> {
      try {
        const product = await this.$api.$post<CreateProductResponse>('/api/product_types.json', { name });

        if (this.autoAttachProduct) await this.$api.$post(`/api/product_types/${product.id}/attach.json`);

        return product;
      } catch (e) {
        this.$notice.error(e);
        this.$sentryUtils.error(e);
      }
    },
  },
});
